export default "__VITE_ASSET__BYAfDWuZ__"